import api from "../util/api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { BuscaContaContabilModel } from "../models/planoContaContabil/buscaContaContabilModel";
import { setLoading } from "../redux/slices/configuracoes/configuracoesSlice";
import { toastError, toastSucess } from "../util/toast";
import { setModalCadastrarPlanoContaContabil, setModalDeletarPlanoContaContabil } from "../redux/slices/planoContaContabil/planoContaContabilSlice";

export const cadastrarPlanoContaContabil = createAsyncThunk("/PlanoContaContabil/CadastrarPlanoContaContabil", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.post("/PlanoContaContabil/CadastrarPlanoContaContabil/", payload.value);
    toastSucess("Plano de conta contábil cadastrado com sucesso");
    dispatch(setModalCadastrarPlanoContaContabil(false));
    dispatch(setLoading(false));

    dispatch(buscarPlanoContaContabil(payload.busca));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});

export const buscarPlanoContaContabil = createAsyncThunk("/PlanoContaContabil/BuscarPlanoContaContabil", async (args: BuscaContaContabilModel) => {
  try {
    const data = await api.get("/PlanoContaContabil/BuscarPlanoContaContabil", { params: args });

    return data.data.data;
  } catch (error: any) {
    throw new Error(error.response.data.Message);
  }
});

export const atualizarPlanoContaContabil = createAsyncThunk("/PlanoContaContabil/AtualizarPlanoContaContabil", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.put("/PlanoContaContabil/AtualizarPlanoContaContabil/", payload.value);
    toastSucess("Plano de conta contábil atualizado com sucesso");
    dispatch(setModalCadastrarPlanoContaContabil(false));
    dispatch(setLoading(false));

    dispatch(buscarPlanoContaContabil(payload.busca));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});

export const atualizarPlanoContaContabilAtivo = createAsyncThunk("/PlanoContaContabil/AtualizarPlanoContaContabilAtivo", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.put("/PlanoContaContabil/AtualizarPlanoContaContabilAtivo", null, {
      params: payload.value,
    });
    toastSucess("Status do plano de conta contábil foi atualizado com sucesso");
    dispatch(setLoading(false));

    dispatch(buscarPlanoContaContabil(payload.busca));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});

export const deletarPlanoContaContabil = createAsyncThunk("/PlanoContaContabil/DeletarPlanoContaContabil", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.delete("/PlanoContaContabil/DeletarPlanoContaContabil/?id=" + payload.value);
    toastSucess("Plano de conta contábil removido com sucesso");
    dispatch(setModalDeletarPlanoContaContabil(false));
    dispatch(setLoading(false));

    dispatch(buscarPlanoContaContabil(payload.busca));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});
